import Button from 'devextreme-react/button';
import { Template } from 'devextreme-react/core/template';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import React, { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Dropdown } from 'semantic-ui-react';
import { truongApi } from '../../api/truongApi';
import appInfo from '../../app-info';
import { useCommonContext } from '../../contexts/common';
import { coSoActionTypes } from '../../state/reducers/coSoReducer';
import { namHocActionTypes } from '../../state/reducers/namHocReducer';
import { truongActionTypes } from '../../state/reducers/truongReducer';
import ComboboxCoSo from '../editor/cmb_coso';
import ComboboxNamHoc from '../editor/cmb_namhoc';
import { GlobalSearch } from "../global-search";
import UserPanel from '../user-panel/user-panel';
import './header.scss';
import useLanguage from '../../hooks/use-language';

export const CommonContext = createContext(null);

const languages = [
  { key: "vn", value: "vn", flag: "vn" },
  { key: "en", value: "en", flag: "us" },
];

export default ({ menuToggleEnabled, title, toggleMenu, menuStatus }) => {
  const [language, setLanguage] = useLanguage();
  const { user } = useSelector(x => x.auth);
  const { dm_truong_id, dm_truongs } = useSelector(x => x.truong);
  const { dm_coso_id } = useSelector(x => x.coSo);
  const { nam_hoc } = useSelector(x => x.namHoc);
  const dispatch = useDispatch();
  const { translate } = useCommonContext();
  let history = useHistory();
  const handleLanguageChange = (e, { value }) => {
    setLanguage(value);
    history.go(0);
  };
  useEffect(() => {
    handleReload();
  }, []);

  const renderLogo = () => {
    return <a onClick={() => {
      window.location.href = appInfo.home_url;
    }}>
      <img src={`${appInfo.home_url}/images/logo_header.png`} className="header-logo" style={{ height: 40 }}></img>
    </a>;
  }

  const handleReload = async () => {
    const dm_truong_ids = user.campus ? user.campus.map((x) => x.id) : [];
    const res = await truongApi.SelectAll();
    if (res.is_success) {
      const dm_truongs = res.data.filter((x) => dm_truong_ids.includes(x.id));
      dispatch({ type: truongActionTypes.LOAD.SUCCESS, payload: dm_truongs });

    }
  };

  const renderSearch = () => {
    return (
      <div style={{
        display: "flex",
        position: "relative",
        left: "140px"
      }}>
        <GlobalSearch />
      </div>
    );
  }


  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>

        <Item location={'before'}
          render={renderLogo}>
        </Item>

        <Item
          visible={true}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <div style={{
            display: "flex",
            position: "relative",
            left: "130px"
          }}>
            <div className='header-nav-btn' onClick={() => {
              history.goBack();
            }}>
              <i className={"fas fa-chevron-left"}></i>
            </div>
            <div className='header-nav-btn' onClick={() => {
              history.goForward();
            }}>
              <i className={"fas fa-chevron-right"}></i>
            </div>
          </div>
        </Item>
        <Item
          location={'before'}
          visible={true}
          render={renderSearch}
        />
        {/* <Item
          location="after"
          cssClass={'cbo-truong'}
          render={() =>
            <SelectBox
              dataSource={dm_truongs}
              displayExpr={'ten_truong'}
              valueExpr={'id'}
              value={dm_truong_id}
              stylingMode="outlined"
              placeholder={translate('Chọn trường')}
              width="100%"
              showClearButton={true}
              onValueChanged={(e) => {
                if (e.event) {
                  dispatch({ type: truongActionTypes.CHANGE_SELECTED_ID, payload: e.value || 0 });
                }
              }}
            />}
        /> */}
        <Item
          location="after"
          cssClass={'cbo-namhoc'}
          render={() =>
            <ComboboxNamHoc
              value={nam_hoc}
              onValueChanged={(value) => {
                dispatch({ type: namHocActionTypes.CHANGE_SELECTED_ID, payload: value })
              }} />
          }
        />
        <Item
          location="after"
          cssClass={'cbo-coso'}
          render={() =>
            <ComboboxCoSo
              value={dm_coso_id}
              onValueChanged={(value) => {
                dispatch({ type: coSoActionTypes.CHANGE_SELECTED_ID, payload: value })
              }} />
          }
        />
        {/* <Item
          location={'center'}
          cssClass={'header-title'}
          text={title}
          visible={!!title}
          render={renderBrandName}
        /> */}

        {/* <Item
          visible={true}
          location={'after'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Popup
            content={() => { return PopupContent(user.sub_systems) }}
            on='click'
            popper={{ id: 'popper-container', style: { zIndex: 2000 } }}
            trigger={<Button icon="menu" stylingMode="text" />}
          />

        </Item> */}
        <Item
          location={'after'}
          locateInMenu={'auto'}
          render={() => {
            return (
              <React.Fragment>
                <div className='select-box-language'>
                  <Dropdown
                    placeholder='Ngôn ngữ/ Language'
                    fluid
                    selection
                    onChange={handleLanguageChange}
                    value={language}
                    options={languages}
                  />
                </div>
              </React.Fragment>
            );
          }}
        />
        <Item
          location={'after'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            width={210}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item>
        <Template name={'userPanelTemplate'}>
          <UserPanel menuMode={'list'} />
        </Template>
      </Toolbar>
    </header>
  );
};

